export default {
  "pl": {
    "issue_status": {
      "actions": {
        "create": "Utwórz stan wydania"
      },
      "labels": {
        "customer_status": "Klient zobaczy",
        "internal_status": "Stan wewnętrzny",
        "new_issue_status": "Stan nowego wydania"
      }
    }
  }
}
